import styles from './ShopTypes.module.scss'
const ShopTypesDivider = ({ dividerClass }) => (
  <div className={styles[dividerClass]} />
)

export default ShopTypesDivider
